"use client"

import { atom, WritableAtom } from 'jotai';
import { atomFamily } from "jotai/vanilla/utils";
import { explorerItemsAtom } from "@/state/jotai/atom/explorerItemsAtom.ts";
import { ExplorerItem } from "@/types/types.ts";

export const explorerItemAtomFamily = atomFamily((key: string) => {
  const itemAtom: WritableAtom<ExplorerItem, [ExplorerItem], void> = atom(
    (get) => {
      const explorerItems = get(explorerItemsAtom);
      return explorerItems[key];
    },
    (_get, set, newItem) => {
      set(explorerItemsAtom, (prev) => ({
        ...prev,
        [key]: newItem,
      }));
    }
  );

  return itemAtom;
})
